export default __webpack_public_path__ + "static/media/spell2.431dfdf9.jpg";